//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

angular.module('curalate').constant('ExperienceCustomizationDefaults', {
  CTA_TEXT: 'Shop Now',
  HEADER_FONT_SIZE: 36,
  SUBHEADER_FONT_SIZE: 20,
});
